// Mandala / geometric watermark — DISABLED platform-wide so no pattern ever sits
// behind text (per design rule: heroes & sections use solid theme surfaces).
export const MandalaMotif = () => null;
const _MandalaMotifArchived = ({ className = "", strokeWidth = 0.5 }) => (
  <svg viewBox="0 0 200 200" fill="none" className={className} aria-hidden="true">
    <g stroke="currentColor" strokeWidth={strokeWidth}>
      <circle cx="100" cy="100" r="92" />
      <circle cx="100" cy="100" r="70" />
      <circle cx="100" cy="100" r="48" />
      <circle cx="100" cy="100" r="26" />
      {Array.from({ length: 24 }).map((_, i) => {
        const a = (i * Math.PI) / 12;
        return (
          <line
            key={i}
            x1={100 + 26 * Math.cos(a)}
            y1={100 + 26 * Math.sin(a)}
            x2={100 + 92 * Math.cos(a)}
            y2={100 + 92 * Math.sin(a)}
          />
        );
      })}
      {Array.from({ length: 12 }).map((_, i) => {
        const a = (i * Math.PI) / 6;
        return (
          <circle key={i} cx={100 + 70 * Math.cos(a)} cy={100 + 70 * Math.sin(a)} r="8" />
        );
      })}
    </g>
  </svg>
);

// Decorative horizontal divider with a central diamond
export const Divider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden="true">
    <span className="h-px w-16 bg-[var(--gold-muted)]" />
    <span className="h-1.5 w-1.5 rotate-45 bg-[var(--gold)]" />
    <span className="h-px w-16 bg-[var(--gold-muted)]" />
  </div>
);
